import React from 'react';
import { ESetCargosMarkersMode } from 'components/map/map-container/hooks/types';
import { useInitMap } from 'components/map/map-container/hooks/use-init-map.ts';
import { useSetCargosMarkers } from 'components/map/map-container/hooks/use-set-cargos-markers.ts';
import { useSetTransportsMarkers } from 'components/map/map-container/hooks/use-set-transports-markers.ts';
import { useSetWarehousesMarkers } from 'components/map/map-container/hooks/use-set-warehouses-markers.ts';
import type { IDefaultMapContainerProps } from 'components/map/map-container/types.ts';

export const DefaultMapContainer: React.FC<IDefaultMapContainerProps> = (props) => {
  const { direction, cargos, warehouses, transports, truckTrailerPairs, handleClickShowBtn, costView = false } = props;
  const { map, mapBoxRef } = useInitMap();

  const cargosMarkersSetMode =
    direction === 'unloading' ? ESetCargosMarkersMode.UNLOADING : ESetCargosMarkersMode.LOADING;

  useSetWarehousesMarkers({ map, warehouses });
  useSetCargosMarkers({ map, cargos, setMode: cargosMarkersSetMode, handleClickShowBtn, costView });

  useSetTransportsMarkers({ map, transports, truckTrailerPairs });

  return <div ref={mapBoxRef} style={{ width: '100%', height: '100%' }} />;
};
